export default __webpack_public_path__ + "static/media/profile.722782ba.svg";